export const ALL_ENTRY_KINDS = ["anime", "manga", "novel"] as const;
export type EntryKind = (typeof ALL_ENTRY_KINDS)[number];

export const KIND_LABELS: Record<EntryKind, string> = {
  anime: "Anime",
  manga: "Manga",
  novel: "Novel",
};

export const KIND_PLURALS: Record<EntryKind, string> = {
  anime: "episodes",
  manga: "chapters",
  novel: "chapters",
};

export function isEntryKind(value: string): value is EntryKind {
  return ALL_ENTRY_KINDS.includes(value as EntryKind);
}

export function entryUrl(slug: string, kind: EntryKind, position: number) {
  return `/entry/${slug}/${kind}/${position}` as const;
}

export function seriesUrl(slug: string) {
  return `/series/${slug}` as const;
}

export function seriesKindUrl(slug: string, kind: EntryKind) {
  return `/series/${slug}/${kind}` as const;
}

export function seriesKindSeasonUrl(slug: string, kind: EntryKind, season: number) {
  return `/series/${slug}/${kind}/${season}` as const;
}

export function kindListUrl(kind: EntryKind) {
  return `/${kind}` as const;
}

export function entityUrl(
  seriesSlug: string,
  entitySlug: string,
  asOfEntryId?: string | number,
): `/${string}` {
  const base = `/entity/${seriesSlug}/${entitySlug}`;
  return (asOfEntryId !== undefined ? `${base}/${asOfEntryId}` : base) as `/${string}`;
}
